import React from 'react';

import reportPageEmptyState from 'styles/assets/svg/reportPageEmptyState.svg';

import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/pages/ReportPage/components/EmptyState/EmptyState.module.scss';

interface Props {
    onAddComponent: () => void;
}

export const EmptyState = ({ onAddComponent }: Props) => {
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleAddComponentClick = (): void => {
        sendEventWithDimensions({
            category: 'Reporting',
            action: 'Component Library Opened',
            label: 'none',
        });
        onAddComponent();
    };

    return (
        <div className={classes.emptyStateWrapper}>
            <div className={classes.emptyState}>
                <img src={reportPageEmptyState} className={classes.reportPageEmptyState} alt={'empty state image'} />
                <div className={classes.emptyStateTitle}>Welcome to your new report</div>
                <div className={classes.emptyStateSubTitle}>
                    Start by adding a component to explore your report data. Components help you highlight patterns,
                    trends, and key information.
                </div>
                <div className={classes.buttonWrapper}>
                    <Button
                        onClick={handleAddComponentClick}
                        startIcon={<MuiIcon icon={'add'} color={'inherit'} />}
                        data-testid={'add-widget-btn'}
                    >
                        Add component
                    </Button>
                </div>
            </div>
        </div>
    );
};
